<ng-container *ngIf="years">
  <div class="timeline-box" *ngIf="years.length > 0">
    <div class="timeline-years" *ngFor="let year of years">
      <div *ngFor="let event of getEvents(year); let i = index" class="timeline-event">
        <div class="timeline-icon">
          <img *ngIf="event.svgIcon" width="48px" [src]="event.svgIcon" />
          <mat-icon *ngIf="event.matIcon" color="primary">{{event.matIcon}}</mat-icon>
        </div>

        <div [class]="getEventCardClass(event)">
          <div class="timeline-card-header">
            <div class="timeline-type">{{ event.title }}</div>
            <div class="timeline-date">{{ event.date | dateFormat }}</div>
          </div>
          <div class="timeline-card-body">
            <div class="timeline-event-content">{{ event.details }}</div>
          </div>
          <div *ngIf="event.leftIcons || event.canUpdate || event.canDelete" class="timeline-footer">
            <div class="timeline-footer-left">
              <ng-container *ngFor="let icon of event.leftIcons">
                <div class="timeline-footer-icon">
                  <mat-icon color="accent" [appTooltip]="icon.tooltip">{{icon.matIcon}}</mat-icon>
                </div>
              </ng-container>
            </div>
            <div class="timeline-footer-left">
              <div *ngIf="event.canUpdate || event.canDelete" class="timeline-footer-icon">
                <button mat-icon-button color="primary" [matMenuTriggerFor]="actions"
                  [matMenuTriggerData]="{data:event}">
                  <mat-icon>more_vert</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="timeline-year">
        <div class="timeline-year-title">{{ year }}</div>
      </div>
    </div>
  </div>

  <mat-menu #actions="matMenu">
    <ng-template matMenuContent let-event="data">
      <ul class="menu-actions">
        <li *ngIf="event.canUpdate">
          <a (click)="triggerUpdate(event)"><mat-icon color="primary">create</mat-icon><span class="text">Modifier
              l'événement</span></a>
        </li>
        <li>
          <a *ngIf="event.canDelete" (click)="triggerDelete(event)">
            <mat-icon color="primary">delete_forever</mat-icon>
            <span class="text">Supprimer l'événement</span>
          </a>
        </li>
      </ul>
    </ng-template>
  </mat-menu>
</ng-container>
